import { ApiProperty } from "@nestjs/swagger";



export class RfcodesDto {

    @ApiProperty()
    rfId:number;

    @ApiProperty()
    rfCodes:string;

    @ApiProperty()
    username:string;


/**
 * 
 * @param rfId 
 * @param rfCodes 
 * @param username 
 */

    constructor(rfId:number,rfCodes:string,username:string){
        this.rfId = rfId;
        this.rfCodes = rfCodes;
        this.username = username;
    }
}